import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import * as React from 'react';

export default function ExpandedClickableIcon({
  icon,
  onClick,
}: {
  icon: JSX.Element;
  onClick?: (e: React.MouseEvent) => void;
}): JSX.Element {
  return (
    <div className={classNames(css(styles.icon))} onClick={onClick}>
      {icon}
    </div>
  );
}

const styles = StyleSheet.create({
  icon: {
    cursor: 'pointer',
    minHeight: '27px',
    minWidth: '27px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
